
import Slider from 'react-slick';   
import  './GovtSlide.css';
const PrevArrow = (props) => (
    <button {...props} className="slick-prev">
      <img src="/img/rentshield/claims_arrow_left.svg" alt="Previous" width="48" height="48" />
    </button>
  );
  
  const NextArrow = (props) => (
    <button {...props} className="slick-next">
      <img src="/img/rentshield/claims_arrow_right.svg" alt="Next" width="48" height="48" />
    </button>
  );


const GovtSlide = ()=>{

//  START cards
// const cards = [
//   { 
//     id: 1, 
//     image: '/img/Solutions/computer_purple.svg',
//     heading: 'White-Labeled Booking Portal', 
//     text: 'Maintain your branding while providing guests with an easy-to-use rental booking experience.' 
//   },
//   { 
//     id: 2, 
//     image: '/img/Solutions/money_purple.svg',
//     heading: 'Flexible Pricing', 
//     text: 'Free to start, only pay when the vehicle is rented or pay monthly for unlimited rentals.' 
//   },
//   { 
//     id: 3, 
//     image: '/img/Solutions/phone_purple.svg',
//     heading: 'On-Demand Convenience', 
//     text: 'Enable guests to book and unlock vehicles directly from their smartphones.' 
//   },
//   { 
//     id: 4, 
//     image: '/img/Solutions/car_purple.svg',
//     heading: 'Fleet & Partner Management', 
//     text: 'Use your own vehicles or partner with trusted local rental businesses to drop off and pick up vehicles.' 
//   },
//   { 
//     id: 5, 
//     image: '/img/Solutions/rentid_purple.svg',
//     heading: 'AI-Powered Driver Verification', 
//     text: 'Ensure safety and trust with instant guest screening through RentID’s Trust and Safety tools.' 
//   },
//   { 
//     id: 6, 
//     image: '/img/Solutions/headset_purple.svg',
//     heading: 'Integrated Guest Support', 
//     text: 'RentAI provides automated assistance and support for guests at any time.' 
//   },
//  ];
// END cards


// START slick
const settings = {
  slidesToShow: 5,
  slidesToScroll: 1,
  margin: 30,
  autoplay: true,
  autoplaySpeed: 2000,
  // autoplaySpeed: 0,  // No delay between scrolls
  // speed: 4000,  // Smooth continuous movement
  // cssEase: 'linear',
  loop: true,
  dots: false,
  arrows: false,
  focusOnSelect: true,
  centerPadding: '30px',
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 1480,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        infinite: true,
        margin: 30,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        margin: 20,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1, // Correcting the key to 'slidesToShow'
        centerPadding: "30px",
      },
    },
  ],
};
// END slick


    return(
        <>
          {/* START govtSlideMain */}
          <section className="govtSlideMain">
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-lg-12">
                            <div className="govtSlideHead">
                                <h2>Support, Security & Simplicity—At Scale</h2>
                                {/* <p>Whether you manage 5 cars or 150, Rentid grows with your department.</p> */}
                            </div>
                      </div>
                  </div>
                </div>
                
                <div className='row justify-content-center'>
                  <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                    <Slider {...settings}>
                        <div className="item">
                          <div className="govtSlideDetail">
                            <img className="img-fluid" src="/img/Solutions/computer_purple.svg" alt="White-Labeled Booking Portal" />
                            <h3>White-Labeled<br/> Booking Portal</h3>
                            <p>Maintain your branding while<br/> providing guests with an easy-to<br/>-use rental booking experience.</p>
                          </div>
                        </div> 

                        <div className="item">
                          <div className="govtSlideDetail">
                            <img className="img-fluid" src="/img/Solutions/money_purple.svg" alt="Flexible Pricing" />
                            <h3>Flexible<br/> Pricing</h3>
                            <p>Free to start, only pay when the<br/> vehicle is rented or pay monthly<br/> for unlimited rentals.</p>
                          </div>
                        </div>

                        <div className="item">
                          <div className="govtSlideDetail">
                            <img className="img-fluid" src="/img/Solutions/phone_purple.svg" alt="On-Demand Convenience" />
                            <h3>On-Demand<br/> Convenience</h3>
                            <p>Enable guests to book and<br/> unlock vehicles directly<br/> from their smartphones.</p>
                          </div>
                        </div> 

                        <div className="item">
                          <div className="govtSlideDetail">
                            <img className="img-fluid" src="/img/Solutions/car_purple.svg" alt="Fleet & Partner Management" />
                            <h3>Fleet & Partner<br/> Management</h3>
                            <p>Use your own vehicles or partner<br/> with trusted local rental businesses<br/> to drop off and pick up vehicles.</p>
                          </div>
                        </div> 

                        <div className="item">
                          <div className="govtSlideDetail">
                            <img className="img-fluid" src="/img/Solutions/rentid_purple.svg" alt="AI-Powered Driver Verification" />
                            <h3>AI-Powered<br/> Driver Verification</h3>
                            <p>Ensure safety and trust with instant<br/> guest screening through RentID’s<br/> Trust and Safety tools.</p>
                          </div>
                        </div> 
                        <div className="item">
                          <div className="govtSlideDetail">
                            <img className="img-fluid" src="/img/Solutions/headset_purple.svg" alt="Integrated Guest Support" />
                            <h3>Integrated Guest<br/> Support</h3>
                            <p>RentAI provides automated<br/> assistance and support<br/> for guests at any time.</p>
                          </div>
                        </div>
                    </Slider>
                </div>
              </div>  

                  {/* <div className="govtSlideSlider">
                      <div className="carousel-container mt-2">
                          <div className="carousel">
                                <div className="carousel-track ">
                                  {cards.map((card) => (
                                    <div key={card.id} className="govtSlideDetail">
                                      <img src={card.image} alt={card.heading1} className="img-fluid" />
                                      <h3>{card.heading}</h3>
                                      <p>{card.text}</p>
                                    </div>
                                  ))}
                                </div>
                            
                                <div className="carousel-track ">
                                  {cards.map((card) => (
                                    <div key={`duplicate-${card.id}`} className="govtSlideDetail">
                                      <img src={card.image} alt={card.heading1} className="img-fluid" />
                                      <h3>{card.heading}</h3>
                                      <p>{card.text}</p>
                                    </div>
                                  ))}
                                </div>
                          </div>
                      </div>
                  </div> */}
          </section>
          {/* END govtSlideMain */}
        </>
    )
}

export default GovtSlide;